import { FormFieldTypes } from "../../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../../components/finalForms/libs/data/ValidationTypes";


const initState = {
  sClientName1: null,
  sContractType: null,
  lInstallmentTypeID: null,
  PurchaseOrderNumber: "",
  Dterminationdate: new Date(),
  EffectiveDate: new Date(),
  contractlength: null,
  sPendingContractName1: null,
};
export const ContractsConfig = {
  name: "AddContracts",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic Contracts Details",
      row: {},
      style: {
        sectionStyle: "mt-2",
      },
      //   wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Contact Information", // Group for contact fields
          style: {
            groupStyle: "mb-3",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "sClientName1",
              label: "Client : ",
              Field_Name: "Client",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sClientName1",
              fieldSetting: {
                isDisable: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-6 col-md-6 col-6 mb-2",
              },
            },
            {
              id: "sContractType",
              label: "Contract Type :",
              Field_Name: "Contract Type",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sContractType",
              fieldSetting: {
                isDisable: true,
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-4 col-4 mb-2 ",
              },
            },
            {
              id: "lInstallmentTypeID",
              label: "Invoice Frequency :",
              Field_Name: "Invoice Frequency",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lInstallmentTypeID",
              fieldSetting: {
                placeholder: "Select Invoice Frequency",
                isLoading: false,
                options: [],
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-4 col-4 mb-2 ",
              },
            },
            {
              id: "PurchaseOrderNumber",
              label: "Purchase Order # :",
              Field_Name: "purchase order",
              fieldType: FormFieldTypes.INPUT,
              dataField: "PurchaseOrderNumber",
              fieldSetting: {
                placeholder: "Enter Purchase Order",
                allowSpace: true,
                maxLength: 20,
              },
              validation: [{ type: validationTypes.MAXLENGTH }, { type: "require" }],
              style: {
                containerCss: "col-lg-6 col-md-4 col-4 mb-2 po-input",
              },
            },
            {
              id: "EffectiveDate",
              label: "Effective Date :",
              Field_Name: "effective date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "EffectiveDate",
              fieldSetting: {
                placeholder: "Enter Effective Date",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-6 col-md-4 col-4 mb-2 ",
              },
            },
            {
              id: "Dterminationdate",
              label: "Termination Date :",
              Field_Name: "termination date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "Dterminationdate",
              fieldSetting: {
                placeholder: "Enter Termination Date",
                allowSpace: true,
                isDisable: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-6 col-md-4 col-4 mb-2",
              },
            },
            {
              id: "contractlength",
              label: "Contract Length(months):",
              Field_Name: "contract length",
              fieldType: FormFieldTypes.NUMERIC,
              dataField: "contractlength",
              fieldSetting: {
                placeholder: "Enter Contract Length",
                maxLength: 2,
              },
              validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-6 col-md-4 col-4 mb-2",
              },
            },
            {
              id: "sPendingContractName1",
              label: "Contract Name :",
              Field_Name: "contract name",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sPendingContractName1",
              fieldSetting: {
                placeholder: "Enter Contract Name",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-4 col-4",
              },
            },
          ],
        },
      ],
    },
  ],
};
